

// import React, { useEffect, useMemo, useState, useCallback } from "react";

// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";
// import { useAuth } from "../context/AuthContext";

// import axiosAuth from "../api/axiosAuth";
// import "../style/ListaEstudiantes.css";



// const FOTO_DEFAULT =
//   "https://cdn-icons-png.flaticon.com/512/149/149071.png";

// export default function ListaEstudiantes() {
//   const { token, logout } = useAuth();

//   const [asignaciones, setAsignaciones] = useState([]);
//   const [seleccion, setSeleccion] = useState({
//     grado: "",
//     grupo: "",
//   });

//   const [estudiantes, setEstudiantes] = useState([]);

//   const [busqueda, setBusqueda] = useState("");
//   const [pagina, setPagina] = useState(1);

//   const [orden, setOrden] = useState({
//     campo: "nombre_completo",
//     direccion: "asc",
//   });

//   const [cargando, setCargando] = useState({
//     cursos: false,
//     lista: false,
//   });

//   const [error, setError] = useState("");

//   const porPagina = 15;

//   /* =====================================================
//      CURSOS
//   ===================================================== */

//   const fetchCursos = useCallback(async () => {
//     if (!token) return;

//     try {
//       setCargando((p) => ({ ...p, cursos: true }));
//       setError("");

//     const res = await axiosAuth.get("/lista-estudiantes/cursos");

//       console.log("Cursos recibidos:", res.data);

//       setAsignaciones(
//         Array.isArray(res.data?.asignaciones)
//           ? res.data.asignaciones
//           : []
//       );
//     } catch (err) {
//       console.error("❌ cursos:", err);

//       if (err.response?.status === 401) logout();

//       setError("No se pudieron cargar los cursos");
//     } finally {
//       setCargando((p) => ({ ...p, cursos: false }));
//     }
//   }, [token, logout]);

//   useEffect(() => {
//     fetchCursos();
//   }, [fetchCursos]);

//   /* =====================================================
//      ESTUDIANTES
//   ===================================================== */

//   useEffect(() => {
//     if (!seleccion.grado || !seleccion.grupo) {
//       setEstudiantes([]);
//       return;
//     }

//     const fetchEstudiantes = async () => {
//       try {
//         setCargando((p) => ({ ...p, lista: true }));
//         setError("");

//        const res = await axiosAuth.get(
//   `/lista-estudiantes/${seleccion.grado}/${seleccion.grupo}`
// );

//         console.log("Estudiantes:", res.data);

//         const lista = Array.isArray(res.data?.estudiantes)
//           ? res.data.estudiantes
//           : [];

//         const normalizados = lista.map((e) => ({
//           ...e,

//           id: e.estudiante_id ?? e.id,

//           documento:
//             e.documento ??
//             e.documento_estudiante ??
//             "",

//           nombre_completo:
//             e.nombre_completo ||
//             `${e.apellidos_estudiante || ""} ${e.nombres_estudiante || ""}`.trim(),
//         }));

//         setEstudiantes(normalizados);
//         setPagina(1);
//       } catch (err) {
//         console.error("❌ estudiantes:", err);

//         if (err.response?.status === 401) logout();

//         setError("Error al cargar estudiantes");
//       } finally {
//         setCargando((p) => ({ ...p, lista: false }));
//       }
//     };

//     fetchEstudiantes();
//   }, [seleccion, logout]);

//   /* =====================================================
//      FILTRO + ORDEN
//   ===================================================== */

//   const estudiantesFiltrados = useMemo(() => {
//     let lista = [...estudiantes];

//     if (busqueda) {
//       const t = busqueda.toLowerCase();

//       lista = lista.filter(
//         (e) =>
//           e.nombre_completo?.toLowerCase().includes(t) ||
//           e.documento?.toLowerCase().includes(t)
//       );
//     }

//     lista.sort((a, b) => {
//       const { campo, direccion } = orden;

//       const valA = (a[campo] || "").toString().toLowerCase();
//       const valB = (b[campo] || "").toString().toLowerCase();

//       if (valA < valB) return direccion === "asc" ? -1 : 1;
//       if (valA > valB) return direccion === "asc" ? 1 : -1;

//       return 0;
//     });

//     return lista;
//   }, [estudiantes, busqueda, orden]);

//   const totalPaginas = Math.ceil(estudiantesFiltrados.length / porPagina);

//   const estudiantesPagina = estudiantesFiltrados.slice(
//     (pagina - 1) * porPagina,
//     pagina * porPagina
//   );

//   const ordenarPor = (campo) => {
//     setOrden((prev) => ({
//       campo,
//       direccion:
//         prev.campo === campo && prev.direccion === "asc"
//           ? "desc"
//           : "asc",
//     }));
//   };

//   /* =====================================================
//      EXPORTAR PDF
//   ===================================================== */

//   const generarPDF = () => {
//     const doc = new jsPDF("landscape");

//     doc.text(
//       `Lista de Estudiantes ${seleccion.grado}° ${seleccion.grupo}`,
//       14,
//       15
//     );

//     autoTable(doc, {
//       startY: 22,
//       head: [["Nombre", "Documento", "Correo", "Teléfono"]],
//       body: estudiantesFiltrados.map((e) => [
//         e.nombre_completo,
//         e.documento,
//         e.email_estudiante || "-",
//         e.telefono_estudiante || "-",
//       ]),
//     });

//     doc.save("lista_estudiantes.pdf");
//   };

//   /* =====================================================
//      EXPORTAR EXCEL
//   ===================================================== */

//   const generarExcel = () => {
//     const datos = estudiantesFiltrados.map((e) => ({
//       Nombre: e.nombre_completo,
//       Documento: e.documento,
//       Correo: e.email_estudiante || "",
//       Teléfono: e.telefono_estudiante || "",
//     }));

//     const ws = XLSX.utils.json_to_sheet(datos);
//     const wb = XLSX.utils.book_new();

//     XLSX.utils.book_append_sheet(wb, ws, "Estudiantes");

//     XLSX.writeFile(wb, "lista_estudiantes.xlsx");
//   };

//   return (
//     <div className="lista-estudiantes-container">

//       <header className="lista-header">
//         <h2>📋 Listado de Estudiantes</h2>

//         <select
//           value={
//             seleccion.grado
//               ? `${seleccion.grado}|${seleccion.grupo}`
//               : ""
//           }
//           onChange={(e) => {
//             const [grado, grupo] = e.target.value.split("|");

//             setSeleccion(
//               grado
//                 ? { grado, grupo }
//                 : { grado: "", grupo: "" }
//             );
//           }}
//         >
//           <option value="">Seleccionar curso</option>

//           {asignaciones.map((a, i) => (
//             <option
//               key={i}
//               value={`${a.grado}|${a.grupo}`}
//             >
//               {a.grado}° {a.grupo}
//             </option>
//           ))}
//         </select>
//       </header>

//       {seleccion.grado && (
//         <>
//           <input
//             placeholder="Buscar estudiante..."
//             value={busqueda}
//             onChange={(e) => {
//               setBusqueda(e.target.value);
//               setPagina(1);
//             }}
//           />

//           <div className="export-buttons">
//             <button onClick={generarPDF}>PDF</button>
//             <button onClick={generarExcel}>Excel</button>
//           </div>

//           <table>

//             <thead>
//               <tr>
//                 <th>Foto</th>
//                 <th onClick={() => ordenarPor("nombre_completo")}>
//                   Nombre
//                 </th>
//                 <th onClick={() => ordenarPor("documento")}>
//                   Documento
//                 </th>
//                 <th>Contacto</th>
//               </tr>
//             </thead>

//             <tbody>

//               {cargando.lista ? (
//                 <tr>
//                   <td colSpan="4">
//                     Cargando...
//                   </td>
//                 </tr>
//               ) : estudiantesPagina.length ? (
//                 estudiantesPagina.map((e) => (
//                   <tr key={e.id}>
//                     <td>

//                       <div className="foto-hover-box">

//                         <img
//                           className="foto-mini"
//                           src={e.foto_estudiante || FOTO_DEFAULT}
//                           onError={(ev) =>
//                             (ev.target.src = FOTO_DEFAULT)
//                           }
//                           alt=""
//                         />

//                         <div className="foto-zoom">
//                           <img
//                             src={e.foto_estudiante || FOTO_DEFAULT}
//                             onError={(ev) =>
//                               (ev.target.src = FOTO_DEFAULT)
//                             }
//                             alt=""
//                           />
//                         </div>

//                       </div>

//                     </td>

//                     <td>{e.nombre_completo}</td>

//                     <td>{e.documento}</td>

//                     <td>
//                       {e.email_estudiante || "-"}
//                       <br />
//                       {e.telefono_estudiante || "-"}
//                     </td>

//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="4">
//                     No hay estudiantes.
//                   </td>
//                 </tr>
//               )}

//             </tbody>

//           </table>

//           <div className="paginacion">

//             <button
//               disabled={pagina === 1}
//               onClick={() => setPagina((p) => p - 1)}
//             >
//               Prev
//             </button>

//             <span>
//               {pagina} / {totalPaginas || 1}
//             </span>

//             <button
//               disabled={
//                 pagina === totalPaginas ||
//                 totalPaginas === 0
//               }
//               onClick={() => setPagina((p) => p + 1)}
//             >
//               Next
//             </button>

//           </div>
//         </>
//       )}

//       {error && <p>{error}</p>}

//     </div>
//   );
// }


///


import React, {
  useEffect,
  useMemo,
  useState,
  useCallback
} from "react";

import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

import { useAuth } from "../context/AuthContext";
import axiosAuth from "../api/axiosAuth";

import "../style/ListaEstudiantes.css";


const FOTO_DEFAULT =
  "https://cdn-icons-png.flaticon.com/512/149/149071.png";


export default function ListaEstudiantes() {


  const {
    token,
    logout
  } = useAuth();



  const [asignaciones,setAsignaciones] = useState([]);

  const [seleccion,setSeleccion] = useState({
    grado:"",
    grupo:""
  });


  const [estudiantes,setEstudiantes] = useState([]);

  const [busqueda,setBusqueda] = useState("");

  const [pagina,setPagina] = useState(1);


  const [orden,setOrden] = useState({
    campo:"nombre_completo",
    direccion:"asc"
  });


  const [cargando,setCargando] = useState({
    cursos:false,
    lista:false
  });


  const [error,setError] = useState("");



  const porPagina = 15;



/* =====================================================
   CURSOS DEL PROFESOR
===================================================== */


const fetchCursos = useCallback(async()=>{


  if(!token) return;


  try {


    setCargando(p=>({
      ...p,
      cursos:true
    }));


    setError("");



    const {data} =
      await axiosAuth.get(
        "/lista-estudiantes/cursos"
      );



    console.log(
      "📚 Cursos:",
      data
    );



    const lista =
      Array.isArray(data)
        ? data
        :
        Array.isArray(data?.asignaciones)
          ? data.asignaciones
          :
          [];



    setAsignaciones(lista);



  }catch(err){


    console.error(
      "❌ Error cursos:",
      err.response?.data || err
    );


    if(err.response?.status===401){
      logout();
    }


    setError(
      "No se pudieron cargar los cursos"
    );


  }finally{


    setCargando(p=>({
      ...p,
      cursos:false
    }));

  }


},[
  token,
  logout
]);




useEffect(()=>{

 fetchCursos();

},[
 fetchCursos
]);





/* =====================================================
   ESTUDIANTES
===================================================== */


useEffect(()=>{


 if(
   !seleccion.grado ||
   !seleccion.grupo
 ){

   setEstudiantes([]);

   return;

 }



const fetchEstudiantes = async()=>{


 try{


  setCargando(p=>({
    ...p,
    lista:true
  }));


  setError("");



  const {data} =
    await axiosAuth.get(
      `/lista-estudiantes/${seleccion.grado}/${seleccion.grupo}`
    );



  console.log(
    "👨‍🎓 Estudiantes:",
    data
  );



  const lista =
    Array.isArray(data)
      ? data
      :
      Array.isArray(data?.estudiantes)
        ? data.estudiantes
        :
        [];




 const normalizados =
 lista.map(e=>({


   ...e,


   id:
     e.id ??
     e.estudiante_id,



   documento:
     e.documento ||
     e.documento_estudiante ||
     "",



   nombre_completo:
     e.nombre_completo ||
     `${e.apellidos_estudiante || ""}
      ${e.nombres_estudiante || ""}`
      .trim()



 }));



 setEstudiantes(
   normalizados
 );


 setPagina(1);



 }catch(err){


  console.error(
    "❌ Error estudiantes:",
    err.response?.data || err
  );



  if(err.response?.status===401){
    logout();
  }



  setError(
    "Error cargando estudiantes"
  );



 }finally{


  setCargando(p=>({
    ...p,
    lista:false
  }));

 }


};



fetchEstudiantes();



},[
 seleccion.grado,
 seleccion.grupo,
 logout
]);





/* =====================================================
   FILTRO Y ORDEN
===================================================== */


const estudiantesFiltrados =
useMemo(()=>{


 let lista=[
   ...estudiantes
 ];



 if(busqueda.trim()){


  const texto =
    busqueda
    .toLowerCase();



  lista =
   lista.filter(e=>

    e.nombre_completo
    ?.toLowerCase()
    .includes(texto)

    ||

    e.documento
    ?.toLowerCase()
    .includes(texto)

   );


 }



 lista.sort((a,b)=>{


  const campo =
    orden.campo;


  const A =
   String(
    a[campo] || ""
   )
   .toLowerCase();



  const B =
   String(
    b[campo] || ""
   )
   .toLowerCase();



  if(A<B)
    return orden.direccion==="asc"
      ? -1
      : 1;


  if(A>B)
    return orden.direccion==="asc"
      ? 1
      : -1;



  return 0;


 });



 return lista;



},[
 estudiantes,
 busqueda,
 orden
]);





const totalPaginas =
Math.ceil(
 estudiantesFiltrados.length /
 porPagina
);



const estudiantesPagina =
estudiantesFiltrados.slice(
 (pagina-1)*porPagina,
 pagina*porPagina
);





const ordenarPor=(campo)=>{


 setOrden(prev=>({


  campo,


  direccion:
   prev.campo===campo &&
   prev.direccion==="asc"
    ? "desc"
    : "asc"



 }));


};





/* =====================================================
   PDF
===================================================== */


const generarPDF=()=>{


const doc =
new jsPDF(
 "landscape"
);



doc.text(
 `Lista estudiantes ${seleccion.grado}° ${seleccion.grupo}`,
 14,
 15
);



autoTable(doc,{

 startY:22,


 head:[
  [
   "Nombre",
   "Documento",
   "Correo",
   "Teléfono"
  ]
 ],


 body:

 estudiantesFiltrados.map(e=>[

  e.nombre_completo,

  e.documento,

  e.email_estudiante || "-",

  e.telefono_estudiante || "-"

 ])


});



doc.save(
 "lista_estudiantes.pdf"
);


};





/* =====================================================
   EXCEL
===================================================== */


const generarExcel=()=>{


const datos =
estudiantesFiltrados.map(e=>({


 Nombre:e.nombre_completo,

 Documento:e.documento,

 Correo:e.email_estudiante || "",

 Telefono:e.telefono_estudiante || ""


}));



const ws =
XLSX.utils.json_to_sheet(datos);



const wb =
XLSX.utils.book_new();



XLSX.utils.book_append_sheet(
 wb,
 ws,
 "Estudiantes"
);



XLSX.writeFile(
 wb,
 "lista_estudiantes.xlsx"
);



};





return (

<div className="lista-estudiantes-container">


<header className="lista-header">


<h2>
📋 Lista de estudiantes
</h2>



<select

value={
 seleccion.grado
 ?
 `${seleccion.grado}|${seleccion.grupo}`
 :
 ""
}


onChange={e=>{


const valor=e.target.value;


if(!valor){

 setSeleccion({
  grado:"",
  grupo:""
 });

 return;

}



const [
 grado,
 grupo
]=valor.split("|");



setSeleccion({
 grado,
 grupo
});



}}

>



<option value="">
Seleccionar curso
</option>



{
asignaciones.map((a,i)=>(

<option

key={
 `${a.grado}-${a.grupo}-${i}`
}


value={
 `${a.grado}|${a.grupo}`
}

>

{a.grado}° {a.grupo}

</option>

))
}


</select>



</header>





{seleccion.grado && (


<>


<input

className="buscador"

placeholder="Buscar estudiante..."

value={busqueda}

onChange={e=>{

setBusqueda(e.target.value);

setPagina(1);

}}

/>



<div className="export-buttons">


<button onClick={generarPDF}>
PDF
</button>


<button onClick={generarExcel}>
Excel
</button>


</div>





<table>


<thead>

<tr>

<th>
Foto
</th>


<th onClick={()=>ordenarPor("nombre_completo")}>
Nombre
</th>


<th onClick={()=>ordenarPor("documento")}>
Documento
</th>


<th>
Contacto
</th>


</tr>

</thead>



<tbody>


{
cargando.lista

?

<tr>
<td colSpan="4">
Cargando...
</td>
</tr>


:

estudiantesPagina.length

?


estudiantesPagina.map(e=>(


<tr key={e.id}>


<td>


<img

className="foto-mini"

src={
 e.foto_estudiante ||
 FOTO_DEFAULT
}


onError={
ev=>{
ev.target.src=FOTO_DEFAULT;
}
}


/>


</td>



<td>
{e.nombre_completo}
</td>



<td>
{e.documento}
</td>



<td>

{e.email_estudiante || "-"}

<br/>

{e.telefono_estudiante || "-"}

</td>



</tr>



))


:


<tr>
<td colSpan="4">
No hay estudiantes
</td>
</tr>


}



</tbody>


</table>




<div className="paginacion">


<button

disabled={
pagina===1
}

onClick={()=>
setPagina(p=>p-1)
}

>

Anterior

</button>



<span>

{pagina} / {totalPaginas || 1}

</span>




<button

disabled={
pagina>=totalPaginas
}

onClick={()=>
setPagina(p=>p+1)
}

>

Siguiente

</button>



</div>



</>


)}





{
error &&
<p className="error">
{error}
</p>
}



</div>

);


}